import api from '../token';

export const ListUnidade = async () => {
  try {
    const response = await api.post('/getUnidade');
    return response.data;
  } catch (error) {
   console.error('Erro ao adicionar produto:', error);
    return [];
  }
};

